module.exports = "<div class=\"loadingBar\">\r\n  <fa name=\"spinner mainColorText\" animation=\"spin\"></fa>\r\n</div>"